// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { question16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-question': IconQuestion;
    }
}

/**
 * The icon component for the 'question' icon
 */
export class IconQuestion extends Icon {
    public constructor() {
        super(question16X16);
    }
}

registerIcon('icon-question', IconQuestion);
export const iconQuestionTag = 'nimble-icon-question';
